var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiPicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.709 20.91c5.45 0 9.96-4.521 9.96-9.96 0-5.45-4.52-9.962-9.97-9.962C5.26.988.748 5.5.748 10.95c0 5.44 4.522 9.961 9.961 9.961Zm0-1.66a8.26 8.26 0 0 1-8.291-8.3c0-4.61 3.672-8.302 8.281-8.302 4.61 0 8.31 3.692 8.31 8.301 0 4.61-3.69 8.301-8.3 8.301Zm-2.9-9.17c.615 0 1.162-.557 1.162-1.338 0-.79-.537-1.347-1.162-1.347-.616 0-1.153.556-1.153 1.347 0 .781.537 1.338 1.153 1.338Zm5.79 0c.616 0 1.163-.557 1.163-1.338 0-.79-.537-1.347-1.162-1.347-.616 0-1.153.556-1.153 1.347 0 .781.537 1.338 1.153 1.338Zm-2.9 5.762c2.041 0 3.408-1.358 3.408-2.002 0-.235-.224-.342-.43-.244-.712.39-1.562.83-2.978.83-1.416 0-2.265-.45-2.969-.83-.214-.098-.439.01-.439.244 0 .644 1.367 2.002 3.408 2.002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiPicker);
export default __webpack_public_path__ + "static/media/emojiPicker.b2288ad0db07ce02f4e7ee6cdef50b0a.svg";
export { ForwardRef as ReactComponent };